module.exports = "<div class=\"form-section\" #section>\n  <div class='form-section-inner' [ngClass]=\"{'mat-card': (workflowId != null && subsections.length === 0)}\">\n    <div class=\"section-title\" *ngIf=\"name != null\">\n      <span class=\"text\">{{ name }}</span>\n      <span class=\"line\"></span>\n    </div>\n\n    <ng-template app-dynamic-rows></ng-template>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/form-section.component.html
// module id = ./src/app/forms/form-section.component.html
// module chunks = main